import * as constants from "./constants";

const initialState = {
  allBadges: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
  search: {},
};

const BadgesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_CATEGORIES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allBadges: action.data,
        isAdding: false,
      };
    case constants.FETCH_CATEGORIES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };

    case constants.CREATE_CATEGORIES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_CATEGORIES_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allBadges: [action.data, ...state.allBadges],
        isAdding: false,
      };
    case constants.CREATE_CATEGORIES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_CATEGORIES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_CATEGORIES_SUCCESS:
      return {
        ...state,
        allBadges: state.allBadges.map((el) =>
          el._id === action.data._id ? { ...el, ...action.data } : el
        ),
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_CATEGORIES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };
    case constants.SET_BADGES_MANAGER_STATE:
      const { search } = state;

      localStorage.setItem(
        "badgesManagerState",
        JSON.stringify({ search, ...action.data })
      );
      return {
        ...state,
        ...action.data,
      };

    default:
      return state;
  }
};

export default BadgesReducer;
